var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-tag',{class:{ 'visitors-no-events-filter': true, 'is-active': _vm.value },attrs:{"type":"filter"},nativeOn:{"click":function($event){return _vm.toggleFilter.apply(null, arguments)}}},[_vm._v(" Hide Visitors with No Events ")])
}
var staticRenderFns = []

export { render, staticRenderFns }